import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from '../../components/common/DataTable';
import MessageBox from "../../components/common/CustomMessageBox";
import CustomDelete from '../../components/common/CustomDeleteAlert';
import CustomModal from "../../components/common/CustomModal";
import { getIndustryType, getRating, getLeadSource, getLeadStatus, getCountries, getBusinessGroup, getStates, getCities, getCompanyTypes, getCompanyOwnershipType, getOwner, getCurrencyList, getBusinessProfile } from '../../services/CommonServices';
import { ENQUIRY_COMPANY_DELETE, ENQUIRY_COMPANY_LIST, } from "../../services/apiRoutes";
import { genericGet } from "../../services/apiServices";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../../components/common/CustomLoader";
import { ClearRounded, } from "@mui/icons-material";
import CustomButton from "../../components/common/CustomButton";
import CustomTextField from "../../components/common/CustomTextField";
import CustomAutocomplete from "../../components/common/CustomAutoComplete";
import CustomFilter from "../../components/common/CustomFilter";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { hasEditPermission, hasDeletePermission } from '../../services/CommonServices'
import { useLocation } from "react-router-dom";
import CreateEnquiryCompany from "../components/CreateForm/CreateEnquiryCompany";
import UpdateEnquiryCompany from "../components/UpdateForm/UpdateEnquiryCompany";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../../components/common/CustomDataTable";

const title = 'Company';

const EnquiryCompany = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null); // State to hold selected ID
    const [clientCompanies, setClientCompanies] = useState([]);
    const [owner, setOwner] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [rowId, setRowId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [permission, setPermissions] = useState()
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [companyOwnershipTypes, setCompanyOwnershipTypes] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);

    const [filterPayload, setFilterPayload] = useState({
        companyName: '',
        mobile: '',
        countryId: '',
        baseCurrency: '',
        fromDate: '',
        toDate: ''
    });

    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);

    const navigate = useNavigate();
    const businessProfile = getBusinessProfile();
    const basePath =
        businessProfile === "partner"
            ? "/partner"
            : "/alexxcansols";


    const handleUpdateClick = (clientCompanyId) => {
        setSelectedId(clientCompanyId);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true);
        setRowId(rowId);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };
    const handleDelete = async (clientCompanyId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');
        try {
            const response = await axios.delete(ENQUIRY_COMPANY_DELETE(clientCompanyId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                fetchClientCompanies();
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: response?.data?.message || "Delete successfully",
                    type: "success",
                });
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Client Company. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the client company.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting client company", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                companyName: '',
                mobile: '',
                countryId: '',
                baseCurrency: '',
                fromDate: '',
                toDate: ''
            });
            fetchClientCompanies(0, pageSize, '');
        };
    }, [pageSize]);


    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        // let mappedPath = currentPath.replace("/alexxcansols", "/app");
        const mappedPath = currentPath.replace(
            /^\/(alexxcansols|app|partner)/,
            "/app"
        );
        let editPermision = hasEditPermission(mappedPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(mappedPath, rolePermisionsData?.permissions)
        setPermissions({
            edit: editPermision,
            delete: deletePermission
        })
    }, [])

    useEffect(() => {
        fetchClientCompanies(page, pageSize,)
    }, [page, pageSize, token,])


    useEffect(() => {
        getCommonData();
    }, []);
    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "clientCompanyName", header: "Company", size: 150, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "country", header: "Country", size: 30, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            { accessorKey: "mobile", header: "Contact No.", size: 150, enableSorting: false, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: "email", header: "Email ID", size: 200, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "companyAdmin", header: "Company Admin", size: 100, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                enableSorting: false,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>

                            <IconButton onClick={() => handleViewClick(row.original.clientCompanyId)}>
                                <VisibilityIcon style={{ color: "#059212" }} />
                            </IconButton>
                            {permission?.edit && <IconButton onClick={() => handleUpdateClick(row.original.clientCompanyId)}>
                                <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                            </IconButton>}
                            {permission?.delete && <IconButton onClick={() => handleOpenDeleteAlert(row.original.clientCompanyId)}>
                                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                            </IconButton>}
                        </div>
                    </>
                ),
            },
        ],
        [permission]
    );

    const fetchClientCompanies = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };
            const response = await genericPost(ENQUIRY_COMPANY_LIST, payload, {});
            if (response.data.success && response.data.enquiryCompany) {
                const clientCompanyData = response.data.enquiryCompany.map((company, index) => ({
                    clientCompanyId: company.clientCompanyId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    clientCompanyName: company.companyName || '',
                    phone: company.telephone || '',
                    mobile: company.mobile || '',
                    email: company.email || '',
                    address: `${company.addressLineOne || ''} ${company.addressLineTwo || ''} ${company.address || ''}`.trim(),
                    companyAdmin: `${company.user?.firstName || ''} ${company.user?.lastName || ''} `.trim(),
                    country: company.country?.name || '',
                    contacts: '',
                }));
                setClientCompanies(clientCompanyData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError('No client companies found');
            }
        } catch (error) {
            setError('Error fetching client companies');
            console.error('Error fetching client companies', error);
        } finally {
            setLoading(false);
        }
    };

    const getCommonData = async () => {
        const countriesData = await getCountries();
        setCountries(countriesData);
        const companyOwnershipData = await getCompanyOwnershipType();
        setCompanyOwnershipTypes(companyOwnershipData);
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const owner = await getOwner();
        setOwner(owner);
    };

    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleViewClick = (clientCompanyId) => {
        navigate(`${basePath}/company/${clientCompanyId}`);
    };

    return (
        <>
            <Box sx={{ padding: '10px' }}>
                <CustomLoader open={loading} />
                <CustomDataTable
                    title={title}
                    columns={columns}
                    data={clientCompanies}
                    buttonTitle="Create"
                    handleOpen={handleOpen}
                    handleFilterButton={filterOpen}
                    fiterButtonTitile="Fiter"
                    rowCount={rowCount}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    fromDate={filterPayload.fromDate || ""}
                    toDate={filterPayload.toDate || ""}
                />

                <CustomModal open={modal}  >
                    <CreateEnquiryCompany
                        handleClose={handleClose}
                        countries={countries}
                        getStates={states}
                        owner={owner}
                        fetchData={fetchClientCompanies}
                        setMessage={setMessage}
                    />
                </CustomModal>

                <CustomModal open={updateModal}  >
                    <UpdateEnquiryCompany
                        clientCompanyId={selectedId}
                        handleClose={handleCloseUpdate}
                        countries={countries}
                        getStates={states}
                        fetchData={fetchClientCompanies}
                        setMessage={setMessage}
                        currencyList={currencyList}
                        owner={owner}
                    />
                </CustomModal>

                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
                <CustomFilter
                    drawerTitle="Filter Options"
                    drawerWidth={300}
                    openDrawer={openDrawer}
                    onClose={filterClose}
                    drawerContent={
                        <>
                            <Box>
                                <Grid container spacing={1} sx={{ padding: 0, }}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            placeholder="Search Company"
                                            type="text"
                                            value={filterPayload.companyName}
                                            onChange={(e) => handleFilterChange('companyName', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            placeholder="Search Mobile"
                                            type="number"
                                            value={filterPayload.mobile}
                                            onChange={(e) => handleFilterChange('mobile', e.target.value)}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomAutocomplete
                                            options={countries}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Select Country"
                                            onChange={(event, newValue) => handleFilterChange("countryId", newValue?.id)}
                                            value={countries.find((item) => item.id === filterPayload.countryId) || null}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="from Date"
                                            type="date"
                                            value={filterPayload.fromDate}
                                            onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                            placeholder="From Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="to Date"
                                            type="date"
                                            value={filterPayload.toDate}
                                            onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                            placeholder="To Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                        <CustomButton
                                            startIcon={<FindReplaceOutlinedIcon />}
                                            title="Apply"
                                            size="small"
                                            variant="contained"
                                            onClick={fetchClientCompanies}
                                        />
                                        <CustomButton
                                            variant="outlined"
                                            title="Clear"
                                            startIcon={<ClearRounded />}
                                            style={cif_fob_style}
                                            onClick={handleClearFilters}
                                        />

                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    }
                />

            </Box>
        </>
    );
};

export default EnquiryCompany;

const cif_fob_style = {
    backgroundColor: '#ffff',
    color: '#007bff',
    textTransform: "capitalize",
    borderRadius: 4,
    border: '1px solid #007bff',
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100px"

}
